import { useNavigation } from '@atom/hooks/useNavigation';
import { Button, TextField } from '@atom/mui';

import { useIsAssistantMessageLoading } from '../hooks/useIsAssitantMessageLoading';

import { useChatAssetDraftContext } from './ChatAssetDraftContext';
import ChatAssetDraftElements from './ChatAssetDraftElements';
import ChatAssetDraftHeader from './ChatAssetDraftHeader';
import ChatAssetDraftMap from './ChatAssetDraftMap';
import ChatAssetDraftRootAttributes from './ChatAssetDraftRootAttributes';

import classes from '../chat.module.css';

const ChatAssetDraftToolLayout = () => {
  const [, { Link }] = useNavigation();
  const isLoading = useIsAssistantMessageLoading();

  const {
    draftAsset,
    creating,
    assetId,
    elementsToShow,
    handleDraftAssetChange,
    handleCreate,
  } = useChatAssetDraftContext();

  const name = draftAsset?.name ?? '';

  if (isLoading || !draftAsset) {
    return null;
  }

  return (
    <div className={classes.assetDraftCard}>
      <ChatAssetDraftHeader />
      <ChatAssetDraftMap />
      <ChatAssetDraftRootAttributes />
      {!!elementsToShow.length && (
        <ChatAssetDraftElements
          elements={elementsToShow}
          path={[]}
          isTopLevel
        />
      )}
      <div className={classes.assetDraftCardFooter}>
        {assetId ? (
          <Link
            to={`/inventory/${assetId}`}
            className={classes.assetDraftCardLink}
          >
            View created asset
          </Link>
        ) : (
          <>
            <TextField
              label="Name"
              value={name}
              onChange={event =>
                handleDraftAssetChange({ name: event.target.value })
              }
              style={{ flex: 1 }}
            />
            <Button
              variant="contained"
              color="primary"
              disabled={creating || !name.trim()}
              onClick={handleCreate}
            >
              {creating ? 'Creating...' : 'Create Asset'}
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default ChatAssetDraftToolLayout;
